<template>
  <TableLayout v-permissions="['template:query']">
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['template:create', 'template:delete']">
        <li><el-button type="primary" @click="$refs.operaTemplateWindow.open('新建模版')" icon="el-icon-plus" v-permissions="['template:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['template:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="模版名称" min-width="100px"></el-table-column>
        <el-table-column prop="code" label="模版编码" min-width="100px"></el-table-column>
        <el-table-column prop="keywords" label="关键字" min-width="200px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="200px"></el-table-column>
        <el-table-column prop="createUserInfo.realname" label="创建人" min-width="120px"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
        <el-table-column prop="updateUserInfo.realname" label="更新人" min-width="120px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="140px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['template:update', 'template:delete', 'template:parameter:query', 'book:text:query'])"
          label="操作"
          min-width="330"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" v-permissions="['template:parameter:query']" @click="$refs.parameterTableWindow.open(row)">配置参数</el-button>
            <el-button type="text" v-permissions="['book:text:query']" @click="$refs.bookTextTableWindow.open(row)">配置文案</el-button>
            <el-button type="text" v-permissions="['template:update']" @click="enable(row)">{{row.disabled | statusText}}</el-button>
            <el-button type="text" icon="el-icon-edit" v-permissions="['template:update']" @click="toIDE(row.id)">代码</el-button>
            <el-button type="text" @click="$refs.operaTemplateWindow.open('编辑模版', row)" icon="el-icon-edit" v-permissions="['template:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['template:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaTemplateWindow ref="operaTemplateWindow" @success="handlePageChange"/>
    <!-- 配置参数 -->
    <ParameterTableWindow ref="parameterTableWindow"/>
    <!-- 配置文案 -->
    <BookTextTableWindow ref="bookTextTableWindow"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaTemplateWindow from '@/components/template/OperaTemplateWindow'
import ParameterTableWindow from '@/components/template/parameter/ParameterTableWindow'
import BookTextTableWindow from '@/components/template/book-text/BookTextTableWindow'
export default {
  name: 'TemplateList',
  extends: BaseTable,
  components: { BookTextTableWindow, ParameterTableWindow, TableLayout, Pagination, OperaTemplateWindow },
  data () {
    return {
      underRevision: false
    }
  },
  methods: {
    toIDE (templateId) {
      window.open(`/ide/${templateId}`)
    },
    // 是否上架模版
    enable (row) {
      if (this.underRevision) return
      this.underRevision = true
      this.api.updateById({
        id: row.id,
        disabled: !row.disabled
      })
        .then(() => {
          this.search()
          this.$tip.success('修改成功')
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.underRevision = false
        })
    }
  },
  created () {
    this.config({
      module: '模版',
      api: '/template/list',
      'field.id': 'id',
      'field.main': 'name'
    })
    this.search()
  }
}
</script>
